import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import type { UserData } from '@hotjar/webapp/domains/common/user-data/model';

export const isHotjarian = (): boolean => {
  const userData = (LocalStorage.get('userData') || {}) as UserData & { userEmail?: string };
  return userData?.userEmail?.endsWith('@hotjar.com') ?? false;
};
